import { useState } from "react";
import {
    Link,
    Modal
} from "@mui/material";
import CustomerIdTable from './CustomerIdTable';
import { getCustomerCrossReferenceRecord } from "../services/api";
import COLORS from '../styles/colors.json';

export default function CustomerId({ odsCustomerId, children }) {
    const [customerIds, setCustomerIds] = useState({});
    const [customerIdTableOpen, setCustomerIdTableOpen] = useState(false);

    const handleClick = async () => {
        const customerIds = await getCustomerCrossReferenceRecord(odsCustomerId);
        console.log({customerIds})
        setCustomerIds(customerIds);
        setCustomerIdTableOpen(true);
    }

    return (
        <>
            <Link
                onClick={handleClick}
                color={COLORS.link}
                style={{ cursor: 'pointer' }}
            >
                {children}
            </Link>
            <Modal
                open={customerIdTableOpen}
                onClose={() => setCustomerIdTableOpen(false)}
            >
                <CustomerIdTable customerIds={customerIds} />
            </Modal>
        </>
    );
}